import 'src/global.css';

import { useEffect } from 'react';

import { LicenseInfo } from '@mui/x-license';

import { usePathname } from 'src/routes/hooks';

import { themeConfig, ThemeProvider } from 'src/theme';

import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { Snackbar } from 'src/components/snackbar';
import { SupportDrawer, SupportDrawerProvider } from 'src/components/support-drawer';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context';
import { LocalizationProvider } from 'src/locales/localization-provider';

// ----------------------------------------------------------------------

type AppProps = {
  children: React.ReactNode;
};

export default function App({ children }: AppProps) {
  LicenseInfo.setLicenseKey(
    '2ea0d887778100e031a7be71f1720079Tz0xMjg3MTUsRT0xODA5MDQzMTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'
  );

  useScrollToTop();

  return (
    <AuthProvider>
      <SettingsProvider defaultSettings={defaultSettings}>
        <LocalizationProvider>
          <SupportDrawerProvider>
            <ThemeProvider
              noSsr
              defaultMode={themeConfig.defaultMode}
              modeStorageKey={themeConfig.modeStorageKey}
            >
              <MotionLazy>
                <ProgressBar />
                <Snackbar />
                <SettingsDrawer defaultSettings={defaultSettings} />
                <SupportDrawer width="23%" />
                {children}
              </MotionLazy>
            </ThemeProvider>
          </SupportDrawerProvider>
        </LocalizationProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

// ----------------------------------------------------------------------

function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
